import Actions from './action';

export const initState = {
	isEmployeeLoading: false,
	employeeData: {},
	isGetEmployeeLoading: false,
	getemployeeData: {},
	isEmployeeDetails: false,
	employeeDetails: [],
	isEmployeeAdd: false,
	employeeAdd: [],
	isNationLoading: false,
	nationalData: [],
	isDelEmployeeLoading: false,
	delemployeeData: [],
	isBankNameLoading: false,
	banknameData: [],
	postapiStatus: 'pending',
	ordercardData: 'p',
	isOrderCardLoading: false,
	salarytemplateData: [],
	isSalaryTemplateLoading: false,
	isUploadbuttonData: 'pending',
	uploadData: {},
	isUploadLoading: false,
	ordervalidate: '',
};

const employeeReducer = (state = initState, action) => {
	switch (action.type) {
		case Actions.types.POST_UPLOAD_DATA_START: {
			console.log('1');
			return {
				...state,
				isUploadLoading: true,
				isUploadbuttonData: 'pending',
			};
		}
		case Actions.types.POST_UPLOAD_DATA_SUCCESS: {
			console.log('2');
			return {
				...state,
				isUploadLoading: false,
				uploadData: action.res,
				isUploadbuttonData: action.res ? 'success' : 'pending',
			};
		}
		case Actions.types.POST_UPLOAD_DATA_ERROR: {
			console.log('3');
			return {
				...state,
				isUploadLoading: false,
				isUploadbuttonData: 'pending',
			};
		}

		case Actions.types.POST_EMPLOYEE_DATA_START: {
			return {
				...state,
				isEmployeeLoading: true,
				postapiStatus: 'pending',
			};
		}
		case Actions.types.POST_EMPLOYEE_DATA_SUCCESS: {
			return {
				...state,
				isEmployeeLoading: false,
				employeeData: action.res,
				postapiStatus: !action.res ? 'success' : 'pending',
			};
		}
		case Actions.types.POST_EMPLOYEE_DATA_ERROR: {
			return {
				...state,
				isEmployeeLoading: false,
				postapiStatus: 'error',
			};
		}
		case Actions.types.GET_EMPLOYEE_DATA_START: {
			return {
				...state,
				isGetEmployeeLoading: true,
			};
		}
		case Actions.types.GET_EMPLOYEE_DATA_SUCCESS: {
			return {
				...state,
				isGetEmployeeLoading: false,
				getemployeeData: action.res,
			};
		}
		case Actions.types.GET_EMPLOYEE_DATA_ERROR: {
			return {
				...state,
				isGetEmployeeLoading: false,
			};
		}
		//
		case Actions.types.DEL_EMPLOYEE_DATA_START: {
			return {
				...state,
				isDelEmployeeLoading: true,
			};
		}
		case Actions.types.DEL_EMPLOYEE_DATA_SUCCESS: {
			return {
				...state,
				isDelEmployeeLoading: false,
				delemployeeData: action.res,
			};
		}
		case Actions.types.DEL_EMPLOYEE_DATA_ERROR: {
			return {
				...state,
				isDelEmployeeLoading: false,
			};
		}
		//
		case Actions.types.GET_NATIONAL_DATA_START: {
			return {
				...state,
				isNationalLoading: true,
			};
		}
		case Actions.types.GET_NATIONAL_DATA_SUCCESS: {
			return {
				...state,
				isNationalLoading: false,
				getnationalData: action.res,
			};
		}
		case Actions.types.GET_NATIONAL_DATA_ERROR: {
			return {
				...state,
				isNationalLoading: false,
			};
		}

		case Actions.types.POST_EMPLOYEE_DETAILS_START: {
			return {
				...state,
				isEmployeeDetails: true,
			};
		}
		case Actions.types.POST_EMPLOYEE_DETAILS_SUCCESS: {
			return {
				...state,
				isEmployeeDetails: false,
				employeeDetails: action.res.data,
			};
		}
		case Actions.types.POST_EMPLOYEE_DETAILS_ERROR: {
			return {
				...state,
				isEmployeeDetails: false,
			};
		}
		case Actions.types.POST_ADD_EMPLOYEE_START: {
			return {
				...state,
				isEmployeeAdd: true,
			};
		}
		case Actions.types.POST_ADD_EMPLOYEE_SUCCESS: {
			return {
				...state,
				isEmployeeAdd: false,
				employeeAdd: action.res,
			};
		}
		case Actions.types.POST_ADD_EMPLOYEE_ERROR: {
			return {
				...state,
				isEmployeeAdd: false,
			};
		}
		case Actions.types.GET_BANK_NAME_START: {
			return {
				...state,
				isBankNameLoading: true,
			};
		}
		case Actions.types.GET_BANK_NAME_SUCCESS: {
			return {
				...state,
				isBankNameLoading: false,
				getbanknameData: action.res,
			};
		}
		case Actions.types.GET_BANK_NAME_ERROR: {
			return {
				...state,
				isBankNameLoading: false,
			};
		}
		case Actions.types.GET_ORDER_CARD_START: {
			return {
				...state,
				isOrderCardLoading: true,
			};
		}
		case Actions.types.GET_ORDER_CARD_SUCCESS: {
			return {
				...state,
				isOrderCardLoading: false,
				ordercardData: action.res,
			};
		}
		case Actions.types.GET_ORDER_CARD_ERROR: {
			return {
				...state,
				isOrderCardLoading: false,
			};
		}

		case Actions.types.GET_SALARY_TEMPLATE_START: {
			return {
				...state,
				isSalaryTemplateLoading: true,
			};
		}
		case Actions.types.GET_SALARY_TEMPLATE_SUCCESS: {
			return {
				...state,
				isSalaryTemplateLoading: false,
				salarytemplateData: action.res,
			};
		}
		case Actions.types.GET_SALARY_TEMPLATE_ERROR: {
			return {
				...state,
				isSalaryTemplateLoading: false,
			};
		}
		default:
			return state;
	}
};

export default employeeReducer;
